import { InjectionToken } from '@angular/core';
import { NgxCmModuleInfo, NGXCMModuleConfig } from '../models';
import { NgxCmAuthProvider } from '../models/ngx-auth-provider';


export const NGX_CM_MODULE_LOADER_REGISTRY =
    new InjectionToken<NgxCmModuleInfo>('NGX_MODULE_LOADER_REGISTRY');

export const NGX_CM_MODULE_CONFIG = new InjectionToken<NGXCMModuleConfig>('NGX_MODULE_LOADER_REGISTRY');

export const NGX_CM_AUTH_PROVIDER = new InjectionToken<NgxCmAuthProvider>('NGX_CM_AUTH_PROVIDER');